/**
 * React Context Provider for GTD Client
 * 
 * This provider makes the GTD client available to all React hooks
 */

import { createContext, useContext, useMemo, createElement, ReactNode } from 'react';
import { GTDClient } from '../../client';
import { HttpClient } from '../../client/http-client';

interface GTDProviderProps {
  children: ReactNode;
  httpClient: HttpClient;
  basePath?: string;
}

const GTDClientContext = createContext<GTDClient | null>(null);

export function GTDProvider({ 
  children, 
  httpClient,
  basePath 
}: GTDProviderProps) {
  const client = useMemo(
    () => new GTDClient(httpClient, basePath),
    [httpClient, basePath]
  );

  return createElement(
    GTDClientContext.Provider,
    { value: client },
    children
  );
}

export function useGTDClient(): GTDClient {
  const client = useContext(GTDClientContext);
  
  if (!client) {
    throw new Error(
      'useGTDClient must be used within a GTDProvider. ' +
      'Make sure to wrap your app with <GTDProvider httpClient={...}>'
    );
  }
  
  return client;
}